import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, Label, LoggedLabel } from './elements';

function Lab022(props) {
  return (
    <Wrapper>
      {props.indicators.map(indicator => (
        <Label
          color={indicator.color}
          key={indicator.key}
          icon={indicator.icon}
          bold
          noPadding={!indicator.value}
        >
          {indicator.value || ''}
        </Label>
      ))}
      {props.logged ? (
        <LoggedLabel icon="icon-check_circle" bold>
          {props.logged}
        </LoggedLabel>
      ) : null}
    </Wrapper>
  );
}

Lab022.propTypes = {
  indicators: PropTypes.array,
};
export default Lab022;
